import SearchUtils from 'utils/search-utils';
import CMSUtils, {CustomTypes} from 'utils/cms';
import DynamicRatesAPI from 'api/dynamic-rates';
import {Page, fetchCity, isMonthlyPage} from 'utils/page-utils';
import {initialState as searchRequestInitialState} from 'store/search-request/search-request-reducer';

const getInitialState = async ({state, cookies, params: {slug}, route}) => {
    const cleanedSlug = slug.replace(/-parking$/, '');
    const city = await fetchCity(state, cleanedSlug);
    const dynamicRates = await DynamicRatesAPI.getRatesByCity(cleanedSlug);
    const pageType = Page.MID_FUNNEL;
    const isMonthly = isMonthlyPage(route);
    const {
        data: {timezone},
    } = city;

    const searchRequest = {
        ...searchRequestInitialState,
        pageType,
        ...SearchUtils.createTimeWindowParams(pageType, {}, timezone),
    };

    if (isMonthly) {
        searchRequest.monthly = isMonthly;
    }

    return {
        ...state,
        city,
        searchRequest,
        page: await CMSUtils.getPageData({
            cookies,
            slug: cleanedSlug,
            city,
            customType: CustomTypes.CITY_MIDFUNNEL,
            pageType,
        }),
        dynamicRates: {
            data: dynamicRates,
        },
    };
};

export default getInitialState;
